import React, { Fragment } from 'react';
import './ViewHeading.scss'
import { Card, Flex, Input, Space, Typography } from 'antd';
import FilterComponent from './filter';
import { MasterConfigs } from '../../interfaces/entity';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
const { Title } = Typography;

interface Props {
  children: any;
  controls?: Array<any>;
  isSmall?: boolean;
  config?: MasterConfigs
  filterVisible?: boolean,
  isSearch?: boolean
}

const ViewHeading: React.FC<Props> = ({
  children,
  controls,
  isSmall,
  config,
  filterVisible,
  isSearch = true
}) => {
  const dispatch = useDispatch();
  const query: any = useSelector((app: any) => app?.app?.query);

  const onChange = (value) => {
    dispatch({
      type: 'REFRESH_TABLE',
      refreshTable: true,
      query: { ...query, search: value, keys: config?.searchKeys ? config?.searchKeys.join(',') : null }
    })
  }

  return (
    <>
      <Space direction='vertical' style={{ width: '100%' }} key={'viewheading'}>
        <Flex justify='space-between' style={{ width: '100%' }} >
          <Title level={5} className='w-2/4'>{children}</Title>
          <Space align='end' size={'small'} direction='horizontal'>
            {isSearch && <Input.Search
              placeholder='Search'
              className='w-full'
              onSearch={(value) => onChange(value)}
            />}
            {controls && (
              <Space align='end' size={'small'} direction='horizontal'>
                {controls.map((control, index) => <Fragment key={index}>
                  {control}
                </Fragment>)}
              </Space>
            )}
          </Space>
        </Flex>
        {filterVisible && <Card>
          <FilterComponent config={config} />
        </Card>}
      </Space>
    </>
  );
}

export default ViewHeading;
